"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminGameGenerateFakeLeaderboardDataResponseGql = exports.AdminGameGenerateFakeLeaderboardDataInputGql = exports.ADMIN_GAME_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.ADMIN_GAME_GENERATE_FAKE_LEADERBOARD_DATA_MUTATION = (0, graphql_tag_1.default) `
  mutation AdminGameGenerateFakeLeaderboardData($input: AdminGameGenerateFakeLeaderboardDataInput!) {
    adminGameGenerateFakeLeaderboardData(input: $input) {
      success
    }
  }
`;
exports.AdminGameGenerateFakeLeaderboardDataInputGql = (0, graphql_tag_1.default) `
  input AdminGameGenerateFakeLeaderboardDataInput {
    gameId: String!
  }
`;
exports.AdminGameGenerateFakeLeaderboardDataResponseGql = (0, graphql_tag_1.default) `
  type AdminGameGenerateFakeLeaderboardDataResponse {
    success: Boolean!
  }
`;
